import React from 'react';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Certification {
  name: string;
  icon: string;
}

interface Coach {
  name: string;
  role: string;
  image: string;
  alt: string;
  specialization: string;
  experience: string;
  certifications: Certification[];
  bio: string;
  imagePosition?: string;
}

const coaches: Coach[] = [
{
  name: 'Amit Khanna',
  role: 'Head Coach & Co-Founder',
  image: "/assets/images/068c32ba-00ac-4f16-ac5c-51df7c930da8-1770460203498.jpg",
  alt: 'Amit Khanna, Head Coach and Co-Founder, India\'s Fastest Man and Elite Athlete with 20 years of coaching experience',
  specialization: 'Sprinting & Athletic Development',
  experience: '20 Years',
  imagePosition: 'object-contain',
  certifications: [
  { name: 'India\'s Fastest Man (1995-1998)', icon: 'TrophyIcon' },
  { name: 'Best Athlete Asia 35+ Category', icon: 'StarIcon' },
  { name: 'Asian Record Holder 100m', icon: 'FlagIcon' },
  { name: 'National Games Best Athlete 1997', icon: 'AcademicCapIcon' }],
  bio: 'From 1995 to 1998, Amit Khanna earned the title of India\'s fastest man. His exceptional achievements include being named the Best Athlete in Asia in the 35+ category and setting a new Asian record in the 100 meters for that age group. In 1997, he was recognized as the Best Athlete of the National Games, setting a national record in the 100 meters and becoming the fastest Indian ever recorded. Amit brings expertise in overall management, sprinting techniques, foundational skills, and fostering a positive environment for young athletes.'
},
{
  name: 'Kanchan Mathpal',
  role: 'Kids Specialist Coach',
  image: "/assets/images/PHOTO-2021-05-26-13-44-32-1770460315036.jpg",
  alt: 'Coach Kanchan Mathpal, Best Athlete of Delhi & NCR, Kids Specialist with young athletes at medal ceremony',
  specialization: 'Kids Training & Sprint Development',
  experience: '10 Years',
  imagePosition: 'object-contain',
  certifications: [
  { name: 'Best Athlete Delhi & NCR', icon: 'TrophyIcon' },
  { name: 'Sprint Specialist', icon: 'BoltIcon' },
  { name: 'Youth Training Expert', icon: 'UserGroupIcon' },
  { name: 'Kids Development Coach', icon: 'StarIcon' }],
  bio: 'Recognized as the best athlete in Delhi and NCR, Kanchan excels in sprints and has a strong background in managing young athletes. Her expertise ensures that our programs cater effectively to both competitive athletes and young beginners.'
},
{
  name: 'Simran',
  role: 'Sprint & Hurdles Coach',
  image: "/assets/images/PHOTO-2024-08-13-18-56-03-1770461242844.jpg",
  alt: 'Coach Simran, Fastest Girl of Delhi, sprint and hurdles specialist demonstrating athletic form',
  specialization: 'Sprints & Hurdles',
  experience: '7+ Years',
  imagePosition: 'object-contain',
  certifications: [
  { name: 'Fastest Girl of Delhi', icon: 'TrophyIcon' },
  { name: 'Sprint Specialist', icon: 'BoltIcon' },
  { name: 'Hurdles Expert', icon: 'FlagIcon' },
  { name: 'Speed Training Certified', icon: 'AcademicCapIcon' }],
  bio: 'Known as the fastest girl in Delhi, Simran brings her expertise in sprints and hurdles to our academy. Her insights and techniques in these high-speed events help athletes achieve peak performance and speed.'
},
{
  name: 'Somvir',
  role: 'Field Events Coach',
  image: "/assets/images/PHOTO-2024-08-13-17-57-16-1770462209112.jpg",
  alt: 'Coach Somvir, National Champion in pole vault and javelin throw, professional photo in GO Speed gear',
  specialization: 'Pole Vault & Javelin Throw',
  experience: '7+ Years',
  imagePosition: 'object-contain',
  certifications: [
  { name: 'National Champion', icon: 'TrophyIcon' },
  { name: 'Pole Vault Specialist', icon: 'FlagIcon' },
  { name: 'Javelin Throw Expert', icon: 'BeakerIcon' },
  { name: 'Technical Events Coach', icon: 'CogIcon' }],
  bio: 'As a national champion with specialized skills in pole vault and javelin throw, Somvir offers expert training in these technical events. His experience at the highest levels of competition helps athletes refine their technique and performance.'
},
{
  name: 'Ajay Kumar',
  role: 'Jump Events Coach',
  image: "/assets/images/image-1770461728065.png",
  alt: 'Coach Ajay Kumar, multiple medal winner in long jump and high jump events at state and inter-college competitions',
  specialization: 'Long Jump & High Jump',
  experience: '8 Years',
  imagePosition: 'object-contain',
  certifications: [
  { name: '🥇 Long Jump Inter College 2017', icon: 'TrophyIcon' },
  { name: '🥇 High Jump Delhi State 2017', icon: 'TrophyIcon' },
  { name: '🥈 High Jump Delhi State 2017', icon: 'StarIcon' },
  { name: '🥈 Long Jump Delhi State 2021', icon: 'StarIcon' }],
  bio: '🥇 Long Jump in Inter college competition University of Delhi 2017 | 🥇 High jump in 77th Delhi State Annual Athletics Meet 2017 | 🥈 High Jump in Delhi State 2017 | 🥈 Long Jump in Delhi State 2021 | 🥉 High jump in Delhi State 2018 | 🥉 High jump Delhi State 2021 | 🥉 High jump in Open Delhi State Athletics Championship 2022'
},
{
  name: 'Preeti',
  role: 'Assistant Coach',
  image: "/assets/images/IMG_8536-1770492598100.jpg",
  alt: 'Coach Preeti in GO Speed Academy black and neon yellow track jacket on professional track',
  specialization: 'Athletic Training & Development',
  experience: '4 Years',
  imagePosition: 'object-contain',
  certifications: [
  { name: 'Athletic Training Certified', icon: 'AcademicCapIcon' },
  { name: 'Youth Development Coach', icon: 'UserGroupIcon' },
  { name: 'Fitness Specialist', icon: 'HeartIcon' },
  { name: 'Performance Coach', icon: 'BoltIcon' }],
  bio: 'Dedicated assistant coach with 4 years of experience in athletic training and development, helping athletes of all levels achieve their performance goals.'
}];


const CoachTeam = () => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-accent/10 rounded-full mb-6">
            <span className="text-accent font-heading font-semibold text-sm">Expert Team</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-primary mb-6 leading-tight">
            Meet Our Certified Coaches
          </h2>
          <p className="text-lg text-text-secondary font-body max-w-3xl mx-auto leading-relaxed">
            Every GO Speed coach brings championship-level expertise combined with genuine passion for helping members achieve their goals.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8">
          {coaches.map((coach, index) =>
          <div
            key={index}
            className="bg-card rounded-2xl overflow-hidden shadow-card hover:shadow-hover transition-all duration-300 border border-border">

              <div className="relative h-96 overflow-hidden bg-muted">
                <AppImage
                src={coach.image}
                alt={coach.alt}
                className={`w-full h-full ${coach.imagePosition || 'object-contain'}`} />

                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent p-6">
                  <h3 className="text-2xl font-heading font-bold text-white mb-1">
                    {coach.name}
                  </h3>
                  <p className="text-accent font-heading font-semibold text-sm">
                    {coach.role}
                  </p>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center justify-between mb-4 pb-4 border-b border-border">
                  <div>
                    <p className="text-xs text-text-secondary font-body mb-1">Specialization</p>
                    <p className="text-sm font-heading font-semibold text-primary">
                      {coach.specialization}
                    </p>
                  </div>
                  <div className="text-right">
                    <p className="text-xs text-text-secondary font-body mb-1">Experience</p>
                    <p className="text-sm font-heading font-semibold text-accent">
                      {coach.experience}
                    </p>
                  </div>
                </div>

                <p className="text-text-secondary text-sm font-body leading-relaxed mb-6">
                  {coach.bio}
                </p>

                <div>
                  <p className="text-xs font-heading font-semibold text-primary mb-3 uppercase tracking-wide">
                    Certifications & Credentials
                  </p>
                  <div className="grid grid-cols-2 gap-3">
                    {coach.certifications.map((cert, idx) =>
                  <div
                    key={idx}
                    className="flex items-center bg-muted rounded-lg p-3">

                        <Icon
                      name={cert.icon as any}
                      size={16}
                      className="text-accent mr-2 flex-shrink-0" />

                        <span className="text-xs text-text-secondary font-body leading-tight">
                          {cert.name}
                        </span>
                      </div>
                  )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="mt-16 bg-accent/5 rounded-2xl p-8 lg:p-12 border border-accent/20">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-6">
            <div className="flex-1">
              <h3 className="text-2xl font-heading font-bold text-primary mb-3">
                Safety & Accreditation
              </h3>
              <p className="text-text-secondary font-body leading-relaxed">
                All GO Speed coaches maintain current certifications, undergo continuous education, and follow strict safety protocols. We're committed to providing the highest standard of professional training.
              </p>
            </div>
            <div className="flex flex-wrap gap-4 lg:flex-shrink-0">
              <div className="flex items-center bg-card rounded-lg px-4 py-3 shadow-card">
                <Icon name="ShieldCheckIcon" size={24} className="text-success mr-3" variant="solid" />
                <div>
                  <p className="text-xs text-text-secondary font-body">Safety Certified</p>
                  <p className="text-sm font-heading font-semibold text-primary">100% Compliant</p>
                </div>
              </div>
              <div className="flex items-center bg-card rounded-lg px-4 py-3 shadow-card">
                <Icon name="AcademicCapIcon" size={24} className="text-accent mr-3" variant="solid" />
                <div>
                  <p className="text-xs text-text-secondary font-body">Credentials</p>
                  <p className="text-sm font-heading font-semibold text-primary">Verified</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default CoachTeam;